import { useState, useEffect } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildRemoveProjectCompanyRequest } from '../utils';

const useRemoveProjectCompany = ({
  companyId,
  initialStateRequestWasMade = false,
  onError,
  onSuccess,
  projectId,
}) => {
  const [requestWasMade, setRequestWasMade] = useState(
    initialStateRequestWasMade
  );
  const {
    loading: isRemovingCompany,
    error: removeCompayError,
    doFetch: doFetchDeleteCompany,
  } = useDataApi();

  const removeProjectCompanyRequest = () => {
    doFetchDeleteCompany(
      ...buildRemoveProjectCompanyRequest(projectId, companyId)
    );
    setRequestWasMade(true);
  };

  useEffect(() => {
    if (removeCompayError === null && requestWasMade && !isRemovingCompany) {
      setRequestWasMade(false);
      onSuccess();
    }

    if (removeCompayError) {
      setRequestWasMade(false);
      onError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeCompayError, isRemovingCompany]);

  return {
    isRemovingCompany,
    removeProjectCompanyRequest,
  };
};

export default useRemoveProjectCompany;
